module.exports = __webpack_public_path__ + "static/media/emina_brand_banner.0bdd08d5.jpg";